(function () {
  function setState(item, open) {
    item.classList.toggle('is-open', open);
    var summary = item.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggle(item) {
    var willOpen = !item.classList.contains('is-open');
    if (willOpen) {
      // Accordion: collapse sibling items at the same level only.
      var parent = item.parentElement;
      parent.querySelectorAll(':scope > details.is-open').forEach(function (sib) {
        if (sib !== item) setState(sib, false);
      });
    }
    setState(item, willOpen);
  }

  function bind(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-faq-cats] details.faq-cat, [data-faq-cats] details.faq-item').forEach(function (item) {
      var summary = item.querySelector(':scope > summary');
      if (!summary || summary.dataset.faqCatBound === 'true') return;
      summary.dataset.faqCatBound = 'true';

      // Content stays in the DOM (details is kept open); the .is-open class drives the visual state.
      summary.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(item);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
